import { storage } from './store';

// The version of this build and of the one the server is now serving.
// CI stamps releases with PLUME_VERSION (vite.config.ts `appVersion`), which
// also writes it to /version.json next to index.html.

/** This build's version, e.g. "1.0.4" (local builds: "1.0.0-dev"). */
export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '0.0.0-dev';

const LAST_SEEN_KEY = 'plume.lastSeenVersion';

/**
 * The version the server is serving now (/version.json, never from a cache),
 * or null when it can't be read (offline, an older build without the file).
 */
export async function fetchServedVersion(fetchImpl: typeof fetch = fetch): Promise<string | null> {
  try {
    const response = await fetchImpl('/version.json', { cache: 'no-store' });
    if (!response.ok) return null;
    const body = (await response.json()) as { version?: unknown };
    const version = typeof body.version === 'string' ? body.version.trim() : '';
    return version || null;
  } catch {
    return null;
  }
}

/**
 * Records this build as the last one the listener opened and returns the
 * version it replaced, or null on a first run or when nothing changed. Each
 * update is therefore reported exactly once.
 */
export function takeVersionChange(current: string = APP_VERSION): { from: string; to: string } | null {
  const previous = storage.read<string | null>(LAST_SEEN_KEY, null);
  if (previous === current) return null;
  storage.write(LAST_SEEN_KEY, current);
  return typeof previous === 'string' && previous ? { from: previous, to: current } : null;
}
